import { useEffect } from "react";
import type { ApolloClient } from "@apollo/client";

import { INSIGHTS_STRUCTURE_EVENTS } from "src/components/shared/TeamMetrics/insightsStructureEvents";
import eventEmitter from "src/services/eventEmitter";

/**
 * getAggregations entries for every team viewed so far stay in the cache
 * (see the merge policy in cache.ts) so revisiting an unchanged team is
 * instant. A structure change can alter any of them, and only the team on
 * screen is refetched, so drop them all and let the next read refetch.
 */
export const useEvictAggregationsOnStructureChange = (
  client: ApolloClient
): void => {
  useEffect(() => {
    const evict = () => {
      client.cache.evict({ id: "ROOT_QUERY", fieldName: "getAggregations" });
      client.cache.gc();
    };
    INSIGHTS_STRUCTURE_EVENTS.forEach((eventName) => {
      eventEmitter.on(eventName, evict);
    });
    return () => {
      INSIGHTS_STRUCTURE_EVENTS.forEach((eventName) => {
        eventEmitter.off(eventName, evict);
      });
    };
  }, [client]);
};
